import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import { getLevels } from "./../../apis/tutorList";
import {
  DropdownButton,
  Dropdown,
  Spinner,
  Image,
  InputGroup,
  FormControl,
  FormGroup,
} from "react-bootstrap";
import { debounce } from "lodash";
import "./../../styles/pages/index.scss";
import SearchSubject from "./../../components/SearchSubject";
class RegForm extends Component {
  constructor() {
    super();
    this.state = {
      toogle: false,
      subject: "",
      location: "",
      levels: [],
      errorMessage: "",
      levelValue: "",
      postCodeArray: [],
      searchmode: false,
      postcodeLoader: false,
    };
  }

  componentDidMount = () => {
    getLevels()
      .then((res) => {
        this.setState({ levels: res.data });
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };

  getPostCode = debounce((text) => {
    this.setState({
      postcodeLoader: true,
    });
    let isInputFieldEmptyRE = /^\s*$/;
    if (!isInputFieldEmptyRE.test(text)) {
      fetch(`https://api.postcodes.io/postcodes/${text}/autocomplete`)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              postCodeArray: response.result,
              searchmode: true,
              postcodeLoader: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            postcodeLoader: false,
          });
        });
    } else {
      this.setState({
        searchmode: false,
        postcodeLoader: false,
        postCodeArray: [],
      });
    }
  }, 200);

  goTosearchTutor = () => {
    const { toogle, subject, location, levels, levelValue } = this.state;
    var regExpr = /^\s+$|^$/gi;
    if (
      (toogle ? !location.match(regExpr) : true) &&
      !levelValue.match(regExpr) &&
      !subject.match(regExpr)
    ) {
      this.setState({
        errorMessage: "",
        levelValue: "",
        location: "",
        subject: "",
      });

      this.props.history.push({
        pathname: "/tutors/search/",
        search: `?mode=${
          toogle === true ? "in-person" : "online"
        }&subject=${subject}&level=${levelValue}${
          toogle === true ? `&postCode=${location}` : ""
        }`,
      });
    } else {
      this.setState({
        errorMessage: "Please specify all the missing fields",
      });
    }
  };
  getSubjectValue = (value) => {
    let subAndLev = value.split("(");
    if (subAndLev.length > 1) {
      let subject = subAndLev[0].substring(0, subAndLev[0].length - 1);
      let level = subAndLev[1].substring(0, subAndLev[1].length - 1);
      this.setState({ subject: subject, levelValue: level, errorMessage: "" });
    } else {
      this.setState({ subject: value, levelValue: "", errorMessage: "" });
    }
  };

  render() {
    const {
      toogle,
      levels,
      levelValue,
      errorMessage,
      postCodeArray,
      searchmode,
      postcodeLoader,
      location,
      subject,
    } = this.state;

    return (
      <Route
        exact
        path="/"
        render={() => (
          <div className="container">
            <div className="banner-card-wrapper-home">
              <div className="banner-card">
                <div className="banner-header">
                  <p className="title">Study Beyond The Classroom</p>
                  <p className="subtitle">Find a tutor in any subject to help you learn more.</p>
                </div>
                <ul
                  className="nav nav-pills row"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item col-lg-6 p-0">
                    <span
                      className={`${
                        toogle === false ? "nav-link active" : "nav-link"
                      }`}
                      style={{
                        borderTopLeftRadius:"7px",
                        borderTopRightRadius:"0px"
                      }}
                      id="pills-profile-tab"
                      data-toggle="pill"
                      onClick={() => {
                        this.setState({
                          toogle: false,
                          errorMessage: "",
                        });
                      }}
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected={toogle === false ? false : true}
                    >
                      Online
                    </span>
                  </li>
                  <li className="nav-item col-lg-6 p-0">
                    <span
                      className={`${
                        toogle === true ? "nav-link active" : "nav-link"
                      }`}
                      id="pills-home-tab"
                      data-toggle="pill"
                      onClick={() => {
                        this.setState({
                          toogle: true,
                          errorMessage: "",
                        });
                      }}
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected={toogle === true ? true : false}
                    >
                      In-Person
                    </span>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className={`tab-pane fade ${
                      toogle === true ? "show active" : ""
                    }`}
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <FormGroup
                          controlId="search"
                          className="form_search"
                        >
                          <InputGroup>
                            <FormControl
                              type="text"
                              className="form-control"
                              placeholder="Enter your location"
                              value={location}
                              onChange={(e) => {
                                this.getPostCode(e.target.value);
                                this.setState({
                                  location: e.target.value,
                                  errorMessage: "",
                                });
                              }}
                            />
                          </InputGroup>
                        </FormGroup>

                        <div
                          style={{
                            display:
                              postcodeLoader ||
                              searchmode ||
                              postCodeArray?.length
                                ? "flex"
                                : "none",
                          }}
                          className={
                            postcodeLoader ||
                            searchmode ||
                            postCodeArray?.length
                              ? "postcode-list-div"
                              : ""
                          }
                        >
                          {!postcodeLoader ? (
                            searchmode && postCodeArray?.length ? (
                              postCodeArray.map((post, index) => (
                                <div
                                  key={index}
                                  style={{margin:"0px"}}
                                  onClick={() =>
                                    this.setState({
                                      location: post,
                                      searchmode: false,
                                      postCodeArray: [],
                                    })
                                  }
                                >
                                  <div className="flex-start-center post-value">
                                    <Image className="img" src={require("./../../assets/icons/gps.png")}/>
                                    <span>{post}</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              "no post code"
                            )
                          ) : (
                            <div className="flex-center-center p-3">
                              <Spinner
                                animation="border"
                                style={{ width: "25px", height: "25px" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row cu-padding">
                      <div className="col-lg-6">
                        {/* <FormControl
                          type="text"
                          class="form-control"
                          placeholder="search your subject"
                          onChange={(e) =>
                            this.setState({
                              subject: e.target.value,
                              errorMessage: "",
                            })
                          }
                        /> */}
                        <SearchSubject
                          subjectValue={subject}
                          getSubjectValue={(value) =>
                            this.getSubjectValue(value)
                          }
                        />
                      </div>
                      <div className="col-lg-6 home-search-dropdown">
                        <DropdownButton
                          id="dropdown-basic-button"
                          className="dropdown"
                          title={
                            <span className="flex-between-center">
                              <span className="search-date">
                                {levelValue ? levelValue : "your level"}
                              </span>
                              <Image
                              style={{ position:"absolute",right:"20px",width: "15px" }}
                              src={require("./../../assets/icons/down-arrow.png")}
                              />
                            </span>
                          }
                        >
                          {levels && levels.length ? (
                            levels.map((level, index) => {
                              return (
                                <Dropdown.Item
                                  className="dropdown-item"
                                  onClick={() =>
                                    this.setState({ levelValue: level })
                                  }
                                  key={index}
                                >
                                  {level}
                                </Dropdown.Item>
                              );
                            })
                          ) : (
                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                          )}
                        </DropdownButton>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <button className="btn btn-succes" onClick={this.goTosearchTutor}>Search</button>
                      </div>

                      {errorMessage ? (
                        <div className="flex-center-center error-message">
                          {errorMessage}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      toogle === false ? "show active" : ""
                    }`}
                    id="pills-profile"
                    role="tabpanel"
                    aria-labelledby="pills-profile-tab"
                  >
                    <div className="row cu-padding">
                      <div className="col-lg-6">
                        {/* <input
                          type="text"
                          class="form-control"
                          placeholder="search your subject"
                          onChange={(e) =>
                            this.setState({
                              subject: e.target.value,
                              errorMessage: "",
                            })
                          }
                        /> */}
                        <SearchSubject
                          subjectValue={subject}
                          getSubjectValue={(value) =>
                            this.getSubjectValue(value)
                          }
                        />
                      </div>
                      <div className="col-lg-6 home-search-dropdown">
                        <DropdownButton
                          id="dropdown-basic-button"
                          className="dropdown"
                          title={
                            <span className="flex-between-center">
                              <span className="search-date">
                                {levelValue ? levelValue : "your level"}
                              </span>
                              <Image
                              style={{ position:"absolute",right:"20px",width: "15px"}}
                              src={require("./../../assets/icons/down-arrow.png")}
                              />
                            </span>
                          }
                        >
                          {levels && levels.length ? (
                            levels.map((level, index) => {
                              return (
                                <Dropdown.Item
                                className="dropdown-item"
                                  onClick={() =>
                                    this.setState({
                                      levelValue: level,
                                      errorMessage: "",
                                    })
                                  }
                                  key={index}
                                >
                                  {level}
                                </Dropdown.Item>
                              );
                            })
                          ) : (
                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                          )}
                        </DropdownButton>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <button className="btn btn-succes" onClick={this.goTosearchTutor}>Search</button>
                      </div>
                      {errorMessage ? (
                        <div className="flex-center-center error-message">
                          {errorMessage}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default withRouter(RegForm);
